import * as React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Modal from "@material-ui/core/Modal";
import Typography from "@material-ui/core/Typography";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

const useStyles = makeStyles((theme: any) => ({
  modal: { display: "flex", alignItems: "center", justifyContent: "center" },
  root: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "white",
    borderRadius: 4,
    maxWidth: ({ width }: any) => {
      return width;
    },
  },
  icon: {
    marginTop: -27,
    fontSize: 100,
    marginLeft: ({ iconMarginLeft }: any) => {
      return iconMarginLeft;
    },
    color: ({ iconColor }: any) => {
      switch (iconColor) {
        case "primary":
          return theme.palette.primary.main;
        case "draft":
          return theme.palette.status.draft;
        default:
          return iconColor;
      }
    },
  },
  title: {
    textAlign: "center",
    marginBottom: 0,
    marginTop: -50,
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
  },
  text: { marginTop: theme.spacing(2), marginBottom: 0 },
}));

export default function AppModal(props) {
  const {
    open,
    handleClose,
    width = 450,
    icon: Icon,
    iconColor = "primary",
    iconMarginLeft = -21,
    title,
    text,
  } = props;
  const classes = useStyles({ width, iconColor, iconMarginLeft });

  return (
    <Modal open={open} onClose={handleClose} className={classes.modal}>
      <React.Fragment>
        <div className={classes.root}>
          {Icon && <Icon className={classes.icon} />}
          <Typography variant="h5" className={classes.title} paragraph>
            {title}
          </Typography>
          <DialogContent className={classes.text}>
            <DialogContentText>{text}</DialogContentText>
          </DialogContent>
          {props.children}
        </div>
      </React.Fragment>
    </Modal>
  );
}
